import axios from 'axios';

export const updateProfile = (data) => {
  return axios.post('/api/user/profile', data);
};

export const checkUsername = async (username) => {
  return axios.get(`/api/auth/check-username?username=${username}`);
};

export const getBalance = async (address) => {
  return axios
    .post('/api/user/all-balance', {
      address: address,
    })
    .then((data) => {
      return data;
    })
    .catch((err) => {
      console.error(err);

      // toast.error("Error occurred while fetching user balance");
    });
};

export const ClaimTotalReward = async (address) => {
  return await axios.post('/api/user/get-all-rewards/' + address);
};

export const stoneRewards = async (address, chainId) => {
  return await axios.get(`/api/nft/staking/${address}/${chainId}`);
};

export const claimStoneRewards = async (address, chainId, oldTotalRewards) => {
  return await axios.post(`/api/nft/staking/${address}/claim/${chainId}`, {
    amount: oldTotalRewards,
  });
};
